import React, { useContext, useEffect } from 'react';
import Intercom, { shutdown } from '@intercom/messenger-js-sdk';
import { ConfigContext } from './base-ui/lib.js';
import { useGlobalState } from './stateProviders/GlobalStateProvider.js';

export function IntercomWrapper(props: { children: any }) {
	const { config }: any = useContext(ConfigContext);

	const globalState = useGlobalState();

	useEffect(() => {
		const intercomEnabledEnvs = ['Production', 'Staging', 'Development'];
		if (!intercomEnabledEnvs.includes(config.environmentName)) return;

		shutdown();

		Intercom({
			app_id: config?.support?.intercomAppId,
			intercom_user_jwt: globalState.appUser?.intercomUserJWT,
			company: {
				id: globalState.company?._id,
				name: globalState.company?.name,
			},
		});

		return () => shutdown();
	}, [config.environmentName, globalState.appUser?.intercomUserJWT]);

	return <>{props.children}</>;
}
